<template>
    <div class="header">
        <div class="lr">
            <div class="left">{{day}}</div>
            <div class="right">
                <div>{{week}}</div>
                <div>{{time}}</div>
            </div>
        </div>
        <img src="../../../../../static/img/10.png" alt="" class="headerBck">
        <div class="title">
            <span class="text">{{schoolName}}</span>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {getAbbreviation} from '@/api/databaseBin.js'
import BaseMixin from '@/views/_mixin'

export default {
  mixins: [BaseMixin],
  data() {
    return {
      day: '',
      time: '',
      week: '',
      schoolName: null
    }
  },
  async created() {
    setInterval(() => {
      this.week = moment().format('dddd')
      this.day = moment().format('LL')
      this.time = moment().format('LTS')
    }, 1000)
    const result = await getAbbreviation()
    if (result[this.dataMapping]) {
      this.schoolName = result[this.dataMapping] + '知识产权数字图谱'
      document.title = this.schoolName
    } else {
      this.schoolName = '知识产权数字图谱'
    }
  }
}
</script>
